import axios from "axios";
import {getField, updateField} from "vuex-map-fields";
import i18n from '@/i18n';
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    savingInProgress: false,
    importCustomersFile: {
      file: null,
      filename: null,
      extension: null,
      external_name: null,
    },
    importOrdersFile:{
      file: null,
      filename: null,
      extension: null,
      external_name: null,
    }
  },
  getters: {
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
  },
  actions: {
    async uploadImportCustomersFile({commit, state, dispatch}, payload) {
      updateField(state, {path:'savingInProgress', value:true});
      let formData = new FormData();
      for ( let key in state.importCustomersFile ) {
        if(typeof state.importCustomersFile[key] === 'object' && key !='file' ) {
          formData.append(key, JSON.stringify(state.importCustomersFile[key]));
        } else {
          formData.append(key, state.importCustomersFile[key]);
        }
      }
      return axios.post(this._vm.$apiURL + '/import-customers-file', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }}
      )
        .then(response => {
          if (response.data.status === 'success') {
            this._vm.$alert({
                  title: this._vm.i18n.t("common.operation_success"),
                  text: this._vm.i18n.t('viewSettings.importExternalData.success_imported_customers_stat', [response.data.imported, response.data.imported_early])
                }
            )
          }
          return true;
        })
        .catch(error => {
          dispatch('common/showError', {'error': error, 'is_alert':true}, {root: true});
        })
        .finally(() => {
          updateField(state, {path: 'savingInProgress', value: false});
        });
    },
    async uploadImportOrdersFile({commit, state, dispatch}, payload) {
      updateField(state, {path:'savingInProgress', value:true});
      let formData = new FormData();
      for ( let key in state.importOrdersFile ) {
        if(typeof state.importOrdersFile[key] === 'object' && key !='file' ) {
          formData.append(key, JSON.stringify(state.importOrdersFile[key]));
        } else {
          formData.append(key, state.importOrdersFile[key]);
        }
      }
      return axios.post(this._vm.$apiURL + '/import-orders-file', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }}
      )
        .then(response => {
          if (response.data.status === 'success') {
            this._vm.$alert({
                  title: this._vm.i18n.t("common.operation_success"),
                  text: this._vm.i18n.t('viewSettings.importExternalData.success_imported_orders_stat', [
                      response.data.imported,
                      response.data.imported_early,
                      response.data.unknown_customers,
                  ])
                }
            )
          }
          return true;
        })
        .catch(error => {
          dispatch('common/showError', {'error': error, 'is_alert':true}, {root: true});
        })
        .finally(() => {
          updateField(state, {path: 'savingInProgress', value: false});
        });
    },

  }
}
